// Single source of truth for all site content.

export const COMPANY = {
  name: "Godavari Builders and Developers",
  shortName: "Godavari",
  established: "1999",
  years: "25+",
  tagline: "We build homes that are as unique as you are",
  city: "Nashik, Maharashtra, India",
  domain: "godavaribuildersanddeveloper.com",
  email: "godavaribuilders@gmail.com", // PLACEHOLDER — to be replaced by client
  address:
    "Shop No. 3, Godavari Park, Near ITI Ambad Link Road, Near Godavari Mart, Wavre Nagar, Kamatwade, Nashik, Maharashtra 422010, India",
  hours: "Mon – Sat: 10:00 AM – 7:00 PM",
  about1:
    "Since 1999, Godavari Builders has been a trusted name in Nashik's real estate landscape, crafting luxurious residential projects that embody elegance and sophistication. With over two and a half decades of expertise, we are renowned for our commitment to excellence, delivering homes that cater to the discerning tastes of our clientele.",
  visionTitle: "A Sense of Belonging",
  vision:
    "At Godavari Builders, we believe that a home is more than just a structure; it's an embodiment of belonging. We strive to create spaces that not only provide comfort and convenience but also foster a deep sense of connection and community.",
};

export const NAV_LINKS = [
  { label: "Home", id: "home" },
  { label: "Properties", id: "properties" },
  { label: "About", id: "about" },
  { label: "Services", id: "services" },
  { label: "Contact", id: "contact" },
];

export const PHONES = {
  founder: { name: "Shri. Ramdas Gaikwad", role: "Founder & Managing Director", phone: "+91 7447 555 058", tel: "+917447555058" },
};

export const SOCIALS = {
  instagram: "https://www.instagram.com/godavaribuilders_nashik/",
  facebook: "https://www.facebook.com/p/Godavari-Builders-Developers-61553059800711/",
  linkedinCompany: "https://in.linkedin.com/company/godavari-builders-and-developers",
  linkedinFounder: "https://in.linkedin.com/in/ramdas-gaikwad-0105032a1",
};

export const STATS = [
  { value: 25, suffix: "+", label: "Years of Experience", testId: "about-stat-years" },
  { value: 7, suffix: "+", label: "Projects Delivered", testId: "about-stat-projects" },
  { value: 100, suffix: "+", label: "Happy Families", testId: "about-stat-families" },
];

// Standard build specifications shared across all Godavari Builders projects.
// Sourced from the official project brochures.
export const STANDARD_SPECIFICATIONS = [
  { label: "Structure", value: "R.C.C. frame structure — external walls 6\" thick, internal walls 4\" thick." },
  { label: "Plaster", value: "External sandface plaster with internal putty finish." },
  { label: "Paint", value: "Internal oil-bound distemper; external Asian cement paint." },
  { label: "Doors", value: "Laminated doors with granite frames for toilet & bath." },
  { label: "Windows", value: "Three-track aluminium sliding windows with mosquito net, safety grill & granite frame." },
  { label: "Flooring", value: "4' x 2' vitrified tile flooring." },
  { label: "Kitchen", value: "Granite platform with stainless-steel sink and full-height ceramic tile dado." },
  { label: "Electrification", value: "Concealed Polycab wiring, modular switches, ample light/fan/plug points and a washing-machine point in the utility area." },
  { label: "Bathrooms", value: "Concealed plumbing, geyser provision, single-lever standard fittings, designer glazed tile dado and anti-skid floor tiles." },
  { label: "Parking", value: "Paver-block / checkered-tile paving with M.S. gate." },
];

export const PROJECTS = [
  {
    id: "shree-samarth",
    name: "Shree Samarth Apartment",
    type: "3 BHK Luxury Flats",
    location: "Adgaon Mhasrul Road, Nashik",
    badge: "One Floor, One Flat",
    image: "/images/project-shree-samarth.jpg",
    description:
      "An exclusive 'One Floor, One Flat' residence offering complete privacy and uncompromised luxury. Each spacious 3 BHK home is finished with premium marble, expansive balconies and panoramic views of Nashik's greenery — a private sanctuary for the discerning few.",
    details: {
      config: "3 BHK Luxury Flats",
      highlight: "One Floor, One Flat — a single private residence on every floor.",
      specifications: STANDARD_SPECIFICATIONS,
      booking: [{ name: "Ramdas Gaikwad", phone: "+91 74472 87695", tel: "+917447287695" }],
    },
  },
  {
    id: "ramikar",
    name: "Ramikar",
    type: "Premium Residential",
    location: "Nashik",
    badge: "Premium Living",
    image: "/images/project-ramikar.jpg",
    description:
      "A statement of contemporary elegance, Ramikar blends bold architecture with warm, liveable interiors. Thoughtfully planned 3 BHK homes designed for modern families who value comfort, light and craftsmanship in equal measure.",
    details: {
      config: "3 BHK Luxurious Flats",
      area: "≈ 1,675 sq.ft. saleable",
      plan: "Typical 1st–5th floor plan",
      specifications: STANDARD_SPECIFICATIONS,
      booking: [
        { name: "Ramdas Gaikwad", phone: "+91 74472 87695", tel: "+917447287695" },
        { name: "Vilas Sonawane", phone: "+91 95526 85268", tel: "+919552685268" },
      ],
    },
  },
  {
    id: "shreeja",
    name: "Shreeja",
    type: "Modern Residential",
    location: "Amrutdham, Adgaon Shiwar, Nashik",
    badge: "Modern Design",
    image: "/images/project-shreeja.jpg",
    description:
      "Clean lines, glass facades and minimalist sophistication define Shreeja. A modern residential address with light-filled 3 BHK homes and a refined, contemporary lifestyle at its heart.",
    details: {
      config: "3 BHK Residences",
      area: "1,600 sq.ft. saleable",
      plan: "Typical 1st–6th floor plan",
      siteAddress: "Sr. No. 250/3/8, Plot No. 7–8, near Amrutdham, Adgaon Shiwar, Nashik.",
      specifications: STANDARD_SPECIFICATIONS,
      booking: [
        { name: "Ramdas Gaikwad", phone: "+91 74472 87695", tel: "+917447287695" },
        { name: "Mayur Londhe", phone: "+91 94034 92183", tel: "+919403492183" },
      ],
    },
  },
  {
    id: "sunrise-park",
    name: "Sunrise Park",
    type: "Residential Complex",
    location: "Rautmala, Karmayogi Nagar, Adgaon Shiwar, Nashik",
    badge: "Sunlit Homes",
    image: "/images/project-sunrise-park.jpg",
    description:
      "Wake up to sunlit homes wrapped in greenery. Sunrise Park is a family-friendly community of bright, airy 2 BHK residences served by a lift — a cheerful, sun-kissed setting to call home, just off the Mumbai–Agra highway.",
    details: {
      config: "2 BHK Homes",
      area: "750 sq.ft. total",
      plan: "Typical floor plan with lift",
      siteAddress: "Rautmala, Karmayogi Nagar, Adgaon Shiwar, Nashik — off NH-13 (Mumbai–Agra Road), near Dhatrak Phata & K.K. Wagh College.",
      specifications: STANDARD_SPECIFICATIONS,
      booking: [{ name: "Ramdas Gaikwad", phone: "+91 74472 87695", tel: "+917447287695" }],
    },
  },
  {
    id: "trineti",
    name: "Trineti Residency",
    type: "Luxury Residential",
    location: "Rautmala, Adgaon, Nashik",
    badge: "Elegant Residency",
    image: "/images/project-trineti.jpg",
    description:
      "An elegant and spacious residency with premium finishes throughout. Trineti offers thoughtfully planned 2 BHK luxury homes crafted for those who appreciate timeless living with every modern convenience.",
    details: {
      config: "2 BHK Luxurious Flats",
      plan: "Typical 1st–6th floor plan",
      siteAddress: "Sr. No. 236/1/3, Plot No. 29, near Mane Nagar Water Tank, Rautmala, Adgaon, Nashik.",
      developer: "Trinity Construction, Nashik",
      specifications: STANDARD_SPECIFICATIONS,
      booking: [
        { name: "Ramdas Gaikwad", phone: "+91 74472 87695", tel: "+917447287695" },
        { name: "Dinesh Das", phone: "+91 98909 75431", tel: "+919890975431" },
        { name: "Brijmohan Agrawal", phone: "+91 98907 24104", tel: "+919890724104" },
      ],
    },
  },
  {
    id: "vrundavan",
    name: "Vrundavan",
    type: "Residential Project",
    location: "Nashik",
    badge: "Serene Living",
    image: "/images/project-vrundavan.jpg",
    description:
      "Nestled among mature trees, Vrundavan offers serene and peaceful living. Earthy tones, deep balconies and a tranquil setting create a calm, harmonious retreat from the pace of the city — comfortable 2 BHK homes for everyday calm.",
    details: {
      config: "2 BHK Homes",
      plan: "Typical 1st–5th floor plan",
      specifications: STANDARD_SPECIFICATIONS,
      booking: [
        { name: "Ramdas Gaikwad", phone: "+91 74472 87695", tel: "+917447287695" },
        { name: "Bharat Yeola", phone: "+91 94222 47571", tel: "+919422247571" },
      ],
    },
  },
  {
    id: "godavari-park",
    name: "Godavari Park",
    type: "Premium Residential",
    location: "Royal Town, Makhmalabad, Nashik",
    badge: "Flagship Project",
    image: "/images/project-godavari-park.jpg",
    description:
      "A premium residential address with a striking facade and a palm-lined arrival. Godavari Park offers well-appointed 2 BHK luxury flats with panoramic views — a standout in our portfolio.",
    details: {
      config: "2 BHK Luxurious Flats",
      area: "775 sq.ft.",
      plan: "Typical floor plan",
      siteAddress: "Survey No. 582, Plot No. 78+79, Royal Town, Shanti Nagar, Makhmalabad, Nashik.",
      specifications: STANDARD_SPECIFICATIONS,
      booking: [
        { name: "Ramdas Gaikwad", phone: "+91 74472 87695", tel: "+917447287695" },
        { name: "Milind Shinde", phone: "+91 80872 68060", tel: "+918087268060" },
        { name: "Ashok Yashod", phone: "+91 70835 35327", tel: "+917083535327" },
      ],
    },
  },
];

export const FEATURES = [
  { icon: "Trophy", title: "25+ Years Legacy", desc: "A trusted name in Nashik's real estate since 1999, delivering homes that stand the test of time." },
  { icon: "Building2", title: "Quality Construction", desc: "Premium materials and modern construction techniques ensure durability and elegance in every project." },
  { icon: "Compass", title: "Vastu Compliant", desc: "Every project is designed with Vastu Shastra principles, ensuring harmony and positive energy." },
  { icon: "Handshake", title: "Transparent Dealings", desc: "Complete transparency in pricing, documentation, and timelines — building trust, one home at a time." },
  { icon: "MapPin", title: "Prime Locations", desc: "Strategically located projects in Nashik's most sought-after neighborhoods with excellent connectivity." },
  { icon: "Home", title: "Customized Solutions", desc: "From spacious 2 BHK homes to 3 BHK luxury flats and row houses — residences tailored to your lifestyle." },
];

export const TESTIMONIALS = [
  { author: "Rajesh & Priya Patil", project: "Godavari Park", initials: "RP", quote: "The entire process was flawless. Their attention to detail and understanding of modern aesthetics is second to none. We found our dream home faster than we ever thought possible." },
  { author: "Santosh Deshmukh", project: "Shree Samarth Apartment", initials: "SD", quote: "The One Floor One Flat concept at Shree Samarth is incredible. Complete privacy, luxury interiors, and a community that feels like family." },
  { author: "Manisha & Amit Joshi", project: "Sunrise Park", initials: "MJ", quote: "From the first meeting to the final handover, the Godavari team was professional and transparent. Our home at Sunrise Park is everything we dreamed of." },
  { author: "Dr. Vikram Kulkarni", project: "Trineti Residency", initials: "VK", quote: "As someone who values quality, I'm impressed by the construction standards at Trineti Residency. Godavari Builders truly delivers what they promise." },
];

export const LEADERS = [
  {
    name: "Shri. Ramdas Gaikwad",
    role: "Founder & Managing Director",
    initials: "RG",
    photo: "/images/ramdas-gaikwad.jpg",
    bio: "With over 25 years of experience in Nashik's real estate industry, Shri. Ramdas Gaikwad founded Godavari Builders with a vision to create homes that foster a deep sense of belonging.",
    phone: "+91 7447 555 058",
    tel: "+917447555058",
    linkedin: "https://in.linkedin.com/in/ramdas-gaikwad-0105032a1",
  },
  {
    name: "Shri. Bhausaheb Shelar",
    role: "Co-Partner & Director",
    initials: "BS",
    bio: "A pillar of strength behind Godavari Builders, Shri. Bhausaheb Shelar brings extensive expertise in project management and construction excellence.",
    phone: null,
    tel: null,
    linkedin: null,
  },
];

export const HOTSPOTS = [
  { x: "22%", y: "34%", place: "right", title: "Premium Materials", desc: "Using premium marble and natural stone, the interiors reflect timeless elegance." },
  { x: "63%", y: "26%", place: "left", title: "Panoramic Views", desc: "Every unit features panoramic views of Nashik's lush greenery." },
  { x: "45%", y: "54%", place: "top", title: "Vastu Compliant", desc: "Vastu-compliant design ensures harmony and positive energy." },
  { x: "80%", y: "58%", place: "left", title: "Landscaped Greens", desc: "Lush landscaped gardens and water features create a serene environment." },
];

export const MAP_EMBED =
  "https://www.google.com/maps?q=Godavari%20Park%2C%20Kamatwade%2C%20Ambad%20Link%20Road%2C%20Nashik%2C%20Maharashtra%20422010&output=embed";

export const MAP_LINK =
  "https://www.google.com/maps/search/?api=1&query=Godavari%20Park%20Kamatwade%20Nashik%20Maharashtra%20422010";
